import {
  Button,
  Card,
  CardContent,
  CardHeader,
  CircularProgress,
  LinearProgress,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Divider,
  Backdrop,
  Snackbar,
  Typography,
  Checkbox,
  RadioGroup,
  FormControlLabel,
  Radio,
  TextField,
  MenuItem,
  CardActions
} from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import SendIcon from '@material-ui/icons/Send';
import PropTypes from 'prop-types';
import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { connect } from 'react-redux';
import axios from 'src/utils/axios';
import { getUser } from 'src/utils/Common';
import Alert from 'src/components/Alert';

const useStyles = makeStyles(theme => ({
  root: {},
  content: {
    minHeight: 430
  },
  backdrop1: {
    zIndex: theme.zIndex.drawer + 1,
    color: '#fff'
  },
  cardsMax: {
    maxHeight: 550,
    minHeight: 550
  }
}));
function SurveyScreen({ className, ReceiptNo, readonly, tasks }) {
  const classes = useStyles();
  const { t } = useTranslation('work_order');
  const [Data, setData] = useState({});
  const SessionUser = getUser();
  const [ResponseDsc, setResponseDsc] = useState('');
  const [SurveyData, setSurveyData] = useState([]);
  const [open, setOpen] = React.useState(false);
  const [Loading, setLoading] = useState(true);
  const [AlertWarning, setAlertWarning] = React.useState(false);
  const [AlertType, setAlertType] = React.useState();

  useEffect(() => {
    const storeData = tasks.tasks.filter(
      d => parseInt(d.ReceiptNo) === parseInt(ReceiptNo)
    );
    if (storeData.length !== 0) {
      setData(storeData[0]);
    } else {
      setData({});
    }
  }, [ReceiptNo, tasks.tasks, readonly]);

  useEffect(() => {
    setLoading(true);
    axios
      .get(`/GetSurveyCustomer/${SessionUser.ServiceShopId}/${ReceiptNo}`)
      .then(response => {
        const ResponseData = response.data.Plan;
        if (ResponseData.length > -1) {
          setSurveyData(ResponseData);
        }
        setLoading(false);
      })
      .catch(error => {
        setSurveyData([]);
        setLoading(false);
      });
  }, [SessionUser.ServiceShopId]);

  const handleClose = () => {
    setOpen(false);
  };

  const AlertClose = (event, reason) => {
    if (reason === 'clickaway') {
      return;
    }
    setAlertWarning(false);
  };

  const handleCheckBoxChange = event => {
    const Data = [...SurveyData];
    if (event.target.checked) {
      const Value = { Selected: parseInt(event.target.value) };
      const index = Data[0].Question.findIndex(
        x => parseInt(x.QuestionId) === parseInt(event.target.name)
      );
      Data[0].Question[index].QuestionAnswer.push(Value);
    } else {
      const indexData = Data[0].Question.findIndex(
        x => parseInt(x.QuestionId) === parseInt(event.target.name)
      );
      const indexSelected = Data[0].Question.filter(
        x => parseInt(x.QuestionId) === parseInt(event.target.name)
      )[0].QuestionAnswer.findIndex(
        y => parseInt(y.Selected) === parseInt(event.target.value)
      );
      Data[0].Question[indexData].QuestionAnswer.splice(indexSelected, 1);
    }
    setSurveyData(Data);
  };

  const handleRadioChange = event => {
    const DataRadio = [...SurveyData];
    const index = DataRadio[0].Question.findIndex(
      x => parseInt(x.QuestionId) === parseInt(event.target.name)
    );
    DataRadio[0].Question[index].QuestionAnswer[0].Selected =
      event.target.value;
    setSurveyData(DataRadio);
  };

  const handleComboChange = event => {
    const Data = [...SurveyData];
    const index = Data[0].Question.findIndex(
      x => parseInt(x.QuestionId) === parseInt(event.target.name)
    );
    Data[0].Question[index].QuestionAnswer[0].Selected = event.target.value;
    setSurveyData(Data);
  };
  const handleTextBoxChange = event => {
    const Data = [...SurveyData];
    const index = Data[0].Question.findIndex(
      x => parseInt(x.QuestionId) === parseInt(event.target.name)
    );
    Data[0].Question[index].QuestionAnswer[0].Selected = event.target.value;
    setSurveyData(Data);
  };

  const getAnswer = (Question, ShowType, index) => {
    let ReturnOject;
    switch (ShowType) {
      case 1:
        ReturnOject = (
          <RadioGroup
            aria-label="Answer"
            size="small"
            name={Question.QuestionId}
            onChange={handleRadioChange}
            value={parseInt(Question.QuestionAnswer[0]?.Selected)}
          >
            {Question?.Answer?.map(AnswerItem => {
              return (
                <FormControlLabel
                  id={AnswerItem.AnswerId}
                  size="small"
                  value={AnswerItem.AnswerId}
                  control={<Radio size="small" />}
                  label={AnswerItem.AnswerDescription}
                />
              );
            })}
          </RadioGroup>
        );
        return ReturnOject;
      case 2:
        ReturnOject = (
          <div>
            {Question?.Answer?.map(AnswerItem => {
              return (
                <FormControlLabel
                  size="small"
                  id={AnswerItem.AnswerId}
                  value={AnswerItem.AnswerId}
                  control={
                    <Checkbox
                      size={'small'}
                      checked={
                        Question.QuestionAnswer?.filter(
                          x => x.Selected.toString() === AnswerItem.AnswerId.toString()
                        ).length > 0
                          ? true
                          : false
                      }
                      onChange={handleCheckBoxChange}
                      name={Question.QuestionId}
                      value={AnswerItem.AnswerId}
                      color="primary"
                    />
                  }
                  label={AnswerItem.AnswerDescription}
                />
              );
            })}
          </div>
        );
        return ReturnOject;
      case 3:
        ReturnOject = (
          <TextField
            size="small"
            fullWidth
            select
            autoComplete="no"
            name={Question.QuestionId}
            value={Question.QuestionAnswer[0]?.Selected}
            onChange={handleComboChange}
            variant="outlined"
          >
            {Question?.Answer?.map(AnswerItem => {
              return (
                <MenuItem key={AnswerItem.AnswerId} value={AnswerItem.AnswerId}>
                  {AnswerItem.AnswerDescription}
                </MenuItem>
              );
            })}
          </TextField>
        );
        return ReturnOject;
      case 4:
        ReturnOject = (
          <TextField
            size="small"
            multiline
            rows={3}
            fullWidth
            name={Question.QuestionId}
            id={Question.Answer[0].AnswerId}
            autoComplete="no"
            onChange={handleTextBoxChange}
            value={
              Question?.QuestionAnswer ? 
              Question?.QuestionAnswer[0]?.Selected?.toString() === '0'
                ? ''
                : Question.QuestionAnswer[0]?.Selected
              :''
            }
            variant="outlined"
          />
        );

        return ReturnOject;
    }
  };

  const setSurvey = () => {
    setLoading(true);
    let RequestSurveyData;
    const RequestData = [];
    let RequestAnswer;
    let Control = 0;

    SurveyData.forEach(item => {
      item.Question.forEach(itemQuestion => {
        RequestAnswer = '';
        itemQuestion.QuestionAnswer.forEach(itemAnswer => {
          if (itemAnswer.Selected.toString() !== '0') {
            RequestAnswer += `,${itemAnswer.Selected}`;
          }
        });
        RequestSurveyData = {
          Question: itemQuestion.QuestionId,
          Answer: RequestAnswer,
          ShowType: itemQuestion.ShowType
        };

        if (RequestAnswer === '') {
          Control = 1;
        }

        RequestData.push(RequestSurveyData);
      });

      if (Control === 1) {
        setResponseDsc(t('lblChooseError'));
        setAlertType('error');
        setAlertWarning(true);
        setLoading(false);
        setOpen(true);
        return;
      }

      const data = {
        ServiceShopId: SessionUser.ServiceShopId,
        EmployeeId: SessionUser.TechnicianId,
        WorkOrderId: ReceiptNo,
        PlanId: item.PlanId,
        Survey: RequestData
      };

      const config = {
        headers: { 'Content-Type': 'application/json' }
      };

      axios
        .post('/SetSurvey', data, config)
        .then(response => {
          setResponseDsc(t('lblSuccess'));
          setAlertType('success');
          setAlertWarning(true);
          setLoading(false);
          setOpen(true);
        })
        .catch(error => {
          setLoading(false);
        });
    });
  };

  return (
    <Card>
      <Snackbar
        open={AlertWarning}
        autoHideDuration={6000}
        onClose={AlertClose}
      >
        <Alert onClose={AlertClose} message={ResponseDsc} variant={AlertType} />
      </Snackbar>
      <CardHeader title={t('Anket_islemleri')} />
      <Divider />
      <CardContent className={classes.contentAnket}>
        {Loading ? <LinearProgress /> : ''}
        {SurveyData?.map((itemPlan, index) => (
          <div key={index}>
            <Typography variant="h6" gutterBottom>
              {itemPlan.PlanDescription}
            </Typography>
            <Divider />
            {itemPlan?.Question?.map((itemQuestion, index) => (
              <div key={index}>
                <Typography variant="h6">
                  {`${index + 1}) ${itemQuestion?.Question}`}
                </Typography>
                {getAnswer(itemQuestion, itemQuestion.ShowType, index)}
              </div>
            ))}
          </div>
        ))}
      </CardContent>
      <CardActions>
        <Button
          variant="contained"
          color="primary"
          size="small"
          onClick={setSurvey}
          endIcon={<SendIcon>Send</SendIcon>}
        >
          {t('lblSave')}
        </Button>
      </CardActions>
      <Dialog
        open={open}
        onClose={handleClose}
        aria-labelledby="alert-dialog-slide-title"
        aria-describedby="alert-dialog-slide-description"
      >
        <DialogTitle id="alert-dialog-slide-title" color="primary">
          {t('Bilgilendirme')}
        </DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-slide-description">
            {ResponseDsc}
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose} color="primary">
            {t('Tamam')}
          </Button>
        </DialogActions>
      </Dialog>
    </Card>
  );
}
SurveyScreen.propTypes = {
  className: PropTypes.string
};
export default connect(state => ({
  tasks: state.tasks1
}))(SurveyScreen);
